var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsHeaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7989 11.0213V16.1231H12.3854V8.33124C12.957 8.52785 14.3042 8.86724 14.9455 9.14753C15.6061 9.4362 15.7989 10.2506 15.7989 11.0213Z",
    fill: "#52545A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44336 16.1231H12.3854M16.5567 16.1231H15.7989M15.7989 16.1231V11.0213C15.7989 10.2506 15.6061 9.4362 14.9455 9.14753C14.3042 8.86724 12.957 8.52785 12.3854 8.33124V16.1231M15.7989 16.1231H12.3854",
    stroke: "#52545A",
    strokeWidth: 0.996065,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06934 16.1251V6.36687C4.06934 4.76422 4.06934 3.96226 4.57439 3.56448C5.07945 3.16669 5.8233 3.38314 7.31166 3.81477L10.5042 4.74124C11.4019 5.00175 11.8508 5.132 12.11 5.48765C12.3699 5.84266 12.3699 6.326 12.3699 7.29397V16.1251",
    fill: "#52545A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06934 16.1251V6.36687C4.06934 4.76422 4.06934 3.96226 4.57439 3.56448C5.07945 3.16669 5.8233 3.38314 7.31166 3.81477L10.5042 4.74124C11.4019 5.00175 11.8508 5.132 12.11 5.48765C12.3699 5.84266 12.3699 6.326 12.3699 7.29397V16.1251",
    stroke: "#52545A",
    strokeWidth: 0.957755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26204 7.82455H9.17755M7.26204 10.3786H9.17755M9.81605 16.6253V14.2096C9.81605 13.6075 9.81605 13.3067 9.62897 13.1197C9.44189 12.9326 9.14115 12.9326 8.53904 12.9326H7.90054C7.29843 12.9326 6.9977 12.9326 6.81062 13.1197C6.62354 13.3067 6.62354 13.6075 6.62354 14.2096V16.645",
    stroke: "white",
    strokeWidth: 0.957755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.23 7.87921V14.6606",
    stroke: "white",
    strokeWidth: 0.766204,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsHeaderIcon);
export default __webpack_public_path__ + "static/media/clients-header-icon.a06b285d7e07fa74b4420f9f9de2c840.svg";
export { ForwardRef as ReactComponent };